import { Directive, ElementRef, HostListener, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Directive({
  selector: '[contenteditableModel]',
  standalone: true,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ContenteditableDirective),
      multi: true
    }
  ]
})
export class ContenteditableDirective implements ControlValueAccessor {
  private onChange: (value: string) => void = () => {};
  private onTouched: () => void = () => {};

  constructor(private elementRef: ElementRef) {}

  @HostListener('input') onInput() {
    this.onChange(this.elementRef.nativeElement.innerHTML);

    let content = this.elementRef.nativeElement.innerHTML
    // ✅ Remove <br> when empty
    if (content.trim() === '<br>' || content.trim() === '') {
      this.elementRef.nativeElement.innerHTML = ''; // Clear content
      this.onChange('');
    } else {
      this.onChange(content);
    }
  }
  // @HostListener('input') onInput() {
  //   const el = this.elementRef.nativeElement;
  
  //   // Get caret position
  //   const selection = window.getSelection();
  //   const range = selection?.getRangeAt(0);
  //   const offset = range?.startOffset || 0;
  
  //   let content = el.innerText; // Use innerText instead of innerHTML
  
  //   // Remove unnecessary spaces or break tags
  //   if (content.trim() === '') {
  //     el.innerText = '';
  //     this.onChange('');
  //   } else {
  //     this.onChange(content);
  //   }
  
  //   // Restore caret position
  //   setTimeout(() => {
  //     const newRange = document.createRange();
  //     newRange.setStart(el.childNodes[0] || el, offset);
  //     newRange.collapse(true);
  //     selection?.removeAllRanges();
  //     selection?.addRange(newRange);
  //   }, 10);
  // }

  
  
  
  
  
  

  @HostListener('blur') onBlur() {
    this.onTouched();
  }

  writeValue(value: string): void {
    this.elementRef.nativeElement.innerHTML = value || '';
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }


}
